import React from 'react';
type AvatarProps = {
  name: string;
  src?: string;
  color?: string;
  className?: string;
};

/** Photo when available, otherwise an initials badge in the event-group palette. */
export function Avatar({
  name,
  src,
  color = 'bg-clay',
  className = ''
}: AvatarProps) {
  if (src) {
    return <img src={src} alt={name} loading="lazy" className={`rounded-full object-cover ${className}`} data-id="element-51" data-mp="1zo9rnu411he" />;
  }
  const initials = name.replace(/[^A-Za-z ]/g, '').split(' ').filter(Boolean).map(w => w[0]).join('').slice(0, 2).toUpperCase() || 'TC';
  return <span aria-label={name} className={`flex items-center justify-center rounded-full font-display text-sm font-bold text-white ${color} ${className}`} data-id="element-52" data-mp="gwnodvndpuld">
      {initials}
    </span>;
}